import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function EinwaageLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [passwort, setPasswort] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res  = await fetch('/api/weighstaff/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password: passwort }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || data.message || 'Login fehlgeschlagen.'); return; }
      localStorage.setItem('token', data.token);
      navigate('/einwaage-staff');
    } catch {
      setError('Verbindungsfehler. Bitte erneut versuchen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.logo}>
          <span style={S.logoIcon}>⚖</span>
          <span style={S.logoText}>Einwaage</span>
        </div>
        <p style={S.subtitle}>Helfer-Login</p>

        <form onSubmit={handleSubmit} style={S.form}>
          <div style={S.field}>
            <label style={S.label}>Benutzername</label>
            <input type="text" required autoComplete="username"
              value={username} onChange={e => setUsername(e.target.value)}
              style={S.input} placeholder="benutzername" />
          </div>
          <div style={S.field}>
            <label style={S.label}>Passwort</label>
            <input type="password" required autoComplete="current-password"
              value={passwort} onChange={e => setPasswort(e.target.value)}
              style={S.input} placeholder="••••••••" />
          </div>
          {error && <div style={S.error}>{error}</div>}
          <button type="submit" disabled={loading}
            style={{ ...S.btn, opacity: loading ? 0.65 : 1 }}>
            {loading ? 'Wird geprüft…' : '⚖ Einloggen'}
          </button>
        </form>
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: '100vh', background: '#0d0a07',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '1.5rem',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  card: {
    width: '100%', maxWidth: 400,
    background: '#161410',
    border: '1px solid rgba(212,175,55,0.15)',
    borderRadius: 14, padding: '2.5rem 2rem',
    boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
  },
  logo: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.6rem', marginBottom: '0.5rem' },
  logoIcon: { fontSize: '2rem', lineHeight: 1, filter: 'drop-shadow(0 0 8px rgba(212,175,55,0.6))' },
  logoText: { fontSize: '1.6rem', fontWeight: 800, color: '#e8dcc8', letterSpacing: '-0.02em' },
  subtitle: { textAlign: 'center', color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem', marginTop: 0, marginBottom: '2rem' },
  form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  field: { display: 'flex', flexDirection: 'column', gap: '0.4rem' },
  label: { fontSize: '0.8rem', fontWeight: 600, color: 'rgba(255,255,255,0.55)', textTransform: 'uppercase', letterSpacing: '0.05em' },
  input: {
    background: '#0d0a07', border: '1px solid rgba(212,175,55,0.2)', borderRadius: 8,
    padding: '0.7rem 0.9rem', color: '#e8dcc8', fontSize: '0.95rem', outline: 'none',
    width: '100%', boxSizing: 'border-box',
  },
  error: {
    background: 'rgba(220,53,69,0.12)', border: '1px solid rgba(220,53,69,0.3)',
    borderRadius: 8, padding: '0.65rem 0.9rem', color: '#ff6b6b', fontSize: '0.875rem',
  },
  btn: {
    background: 'linear-gradient(135deg, #d4af37, #a0842a)',
    color: '#0d0a07', border: 'none', borderRadius: 8,
    padding: '0.85rem', fontSize: '1rem', fontWeight: 700,
    cursor: 'pointer', transition: 'opacity 0.2s ease',
    marginTop: '0.5rem', letterSpacing: '0.01em',
  },
};
